import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { RootState } from 'src/app/store/root.reducer';
import { Store } from '@ngrx/store';
import * as UserAction from '../../store/user/actions/user.actions'
import { APIEndpoint } from 'src/app/models/options/api-endpoint';
@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {

  constructor(
    private store: Store<RootState>,
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap(
        res => { },
        (error: HttpErrorResponse) => {
          switch (error.status) {
            case 401:
              error.url.indexOf(APIEndpoint.TIMESLOT_LOG_IN) === -1
                ? this.store.dispatch(UserAction.invalidateToken({}))
                : (this.store.dispatch(UserAction.setuiloginFail({ uiloginFail: true })),
                  this.store.dispatch(UserAction.clearuiloginLoading()))
              break
            default: { }
          }
        }
      )
    )
  }
}
